import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';


export const searchStakeholders = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/Drug/search-stakeholder`,
  method: 'get',
  query
});


export const searchStakeholdersBySubscriptionType = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/Drug/search-stakeholders-by-subscription-type`,
  method: 'get',
  query
});

export const searchStakeholdersDrug = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/Portal/Drug/search-stakeholder-drug`,
  method: 'get',
  query
});

export const DrugSaleToGLN = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/sop-pharmacy-gln-list`,
  method: 'get',
  query
});

export const searchSOPStakeholders = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-stakeholder-search`,
  method: 'get',
  query
});


export const searchSMPStakeholders = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/smp-stakeholder-grid`,
  method: 'get',
  query
});

export const getSMPStakeholder = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/edit-smp-stakeholder?stakeholderId=${id}`,
  method: 'get'
});
export const editSMPStakeholder = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/smp-company-stakeholder-edit`,
  method: 'post',
  data
});

export const searchSMPStakeholderInProccess = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/smp-stakeholder-is-request-inprocess`,
  method: 'get',
  query
});

export const stakeholderRequestData = requestID => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/revise-smp-stakeholder?stakeholderId=${requestID}`,
  method: 'get',
  requestID
});

export const editStakeholderRequest = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/smp-company-stakeholder-revise`,
  method: 'post',
  form
});


export const smpCompanyStakeholder = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/smp-company-stakeholder`,
  method: 'post',
  form
});
